// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#editor[data-v-40f177e4]{min-height:250px;padding:12px;border-bottom:.05rem solid #000!important}#editor[data-v-40f177e4]  .ql-tooltip{display:none!important}", ""]);
// Exports
module.exports = exports;
